import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Users, Award, TrendingUp, ArrowRight } from 'lucide-react';
import './About.css';

const About = () => {
  const values = [
    {
      icon: <Target size={40} />,
      title: 'Precision & Accuracy',
      description: 'We maintain the highest standards in accounting and advisory services, ensuring every detail is accurate and compliant.'
    },
    {
      icon: <Users size={40} />,
      title: 'Client-Centric Approach',
      description: 'Your business needs are at the heart of everything we do. We provide personalized solutions that work for you.'
    },
    {
      icon: <Award size={40} />,
      title: 'Professional Excellence',
      description: 'Our team brings years of expertise in UAE regulations, taxation, and business advisory services.'
    },
    {
      icon: <TrendingUp size={40} />,
      title: 'Growth Partnership',
      description: 'We don\'t just provide services – we partner with you to drive sustainable business growth and success.'
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1 className="about-hero-title">About Fabsome Consulting</h1>
          <p className="about-hero-subtitle">
            Your trusted partner for professional consulting services in the UAE
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="about-content-section">
        <div className="about-content">
          <div className="content-block">
            <h2 className="content-title">Who We Are</h2>
            <p className="content-text">
              Fabsome Consulting FZ LLE is a UAE-based professional consulting firm dedicated to helping businesses navigate the complexities of accounting, taxation, and regulatory compliance. We specialize in providing practical, reliable solutions that empower SMEs and growing businesses to thrive in the dynamic UAE market.
            </p>
            <p className="content-text">
              With deep expertise in UAE Federal Tax Authority regulations and business advisory, we serve as a trusted partner for companies seeking clarity, compliance, and strategic growth support. Our team possesses over 10+ years of experience in the fields of accounts, audit, taxation, and consulting.
            </p>
          </div>

          <div className="content-block">
            <h2 className="content-title">Our Mission</h2>
            <p className="content-text">
              To provide businesses in the UAE with exceptional consulting services that ensure regulatory compliance, financial accuracy, and sustainable growth. We are committed to delivering practical solutions that make a real difference to our clients' success.
            </p>
          </div>

          <div className="content-block">
            <h2 className="content-title">What Sets Us Apart</h2>
            <p className="content-text">
              At Fabsome Consulting, we combine technical expertise with a genuine understanding of your business challenges. We don't believe in one-size-fits-all solutions. Instead, we take the time to understand your specific needs and provide tailored advisory services that deliver tangible results.
            </p>
            <p className="content-text">
              Whether you need support with VAT compliance, corporate tax advisory, ICV certification, or e-invoicing implementation, our team brings the knowledge and experience to guide you every step of the way.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="section-header">
          <h2 className="section-title">Our Core Values</h2>
          <p className="section-subtitle">
            The principles that guide everything we do
          </p>
        </div>

        <div className="values-grid">
          {values.map((value, index) => (
            <div key={index} className="value-card dark-hover dark-transition">
              <div className="value-icon">{value.icon}</div>
              <h3 className="value-title">{value.title}</h3>
              <p className="value-description">{value.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Industries We Serve */}
      <section className="industries-section">
        <div className="section-header">
          <h2 className="section-title">Industries We Serve</h2>
        </div>

        <div className="industries-grid">
          <div className="industry-card">
            <h3 className="industry-title">Trading & Distribution</h3>
            <p className="industry-description">
              Supporting import-export businesses with VAT compliance and accounting services
            </p>
          </div>
          <div className="industry-card">
            <h3 className="industry-title">Professional Services</h3>
            <p className="industry-description">
              Consulting firms, legal practices, and service providers across the UAE
            </p>
          </div>
          <div className="industry-card">
            <h3 className="industry-title">Technology & Startups</h3>
            <p className="industry-description">
              Growing tech companies navigating UAE business regulations and tax requirements
            </p>
          </div>
          <div className="industry-card">
            <h3 className="industry-title">Manufacturing</h3>
            <p className="industry-description">
              Production facilities requiring ICV advisory and comprehensive tax support
            </p>
          </div>
          <div className="industry-card">
            <h3 className="industry-title">Retail & E-commerce</h3>
            <p className="industry-description">
              Online and offline retailers managing complex VAT scenarios and compliance
            </p>
          </div>
          <div className="industry-card">
            <h3 className="industry-title">Construction & Real Estate</h3>
            <p className="industry-description">
              Property developers and contractors with specialized accounting needs
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta-section">
        <div className="about-cta-content">
          <h2 className="about-cta-title">Partner With Us</h2>
          <p className="about-cta-description">
            Let's discuss how Fabsome Consulting can support your business growth and compliance needs
          </p>
          <Link to="/contact" className="btn-primary btn-large">
            Get In Touch
            <ArrowRight size={24} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;